import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  loading: {
    id: 'library.loading',
    defaultMessage: 'Loading documents',
    description: 'Screen reader text shown while the library documents are loading',
  },
  loadError: {
    id: 'library.loadError',
    defaultMessage: 'Failed to load documents. Please try again later.',
    description: 'Error message shown when the library fails to load',
  },
  emptyTitle: {
    id: 'library.empty.title',
    defaultMessage: 'No documents yet!',
    description: 'Empty state title shown when no documents are available in the library',
  },
  emptyDescription: {
    id: 'library.empty.description',
    defaultMessage: 'Documents shared with you will appear here.',
    description: 'Empty state description shown when no documents are available in the library',
  },
  tableAriaLabel: {
    id: 'library.table.ariaLabel',
    defaultMessage: 'Library files',
    description: 'Accessible label for the library files table',
  },
  columnName: {
    id: 'library.table.column.name',
    defaultMessage: 'File Name',
    description: 'Library files table column header for the file name',
  },
  columnType: {
    id: 'library.table.column.type',
    defaultMessage: 'File Type',
    description: 'Library files table column header for the file type',
  },
  columnUpdated: {
    id: 'library.table.column.updated',
    defaultMessage: 'Last Updated',
    description: 'Library files table column header for when the file was last updated',
  },
  columnSize: {
    id: 'library.table.column.size',
    defaultMessage: 'Size',
    description: 'Library files table column header for the file size',
  },
  columnActions: {
    id: 'library.table.column.actions',
    defaultMessage: 'Actions',
    description: 'Library files table column header for the row actions',
  },
  previewFile: {
    id: 'library.actions.preview',
    defaultMessage: 'Preview {name}',
    description: 'Accessible label for the icon button that previews a file in the library',
  },
  downloadFile: {
    id: 'library.actions.download',
    defaultMessage: 'Download {name}',
    description: 'Accessible label for the icon button that downloads a file from the library',
  },
  lastUpdatedLabel: {
    id: 'library.card.lastUpdated',
    defaultMessage: 'Last Updated: {date}',
    description: 'Label showing when a file was last updated on the library file card',
  },
  headerTitle: {
    id: 'library.header.title',
    defaultMessage: 'Your Library',
    description: 'Heading for the library page',
  },
  sortByLabel: {
    id: 'library.header.sortByLabel',
    defaultMessage: 'Sort by:',
    description: 'Label preceding the library sort dropdown',
  },
  sortLatest: {
    id: 'library.header.sortLatest',
    defaultMessage: 'Latest',
    description: 'Sort option for ordering library files from newest to oldest',
  },
  sortOldest: {
    id: 'library.header.sortOldest',
    defaultMessage: 'Oldest',
    description: 'Sort option for ordering library files from oldest to newest',
  },
  switchToTableView: {
    id: 'library.header.switchToTableView',
    defaultMessage: 'Switch to table view',
    description: 'Accessible label for the library view toggle when grid view is active',
  },
  switchToGridView: {
    id: 'library.header.switchToGridView',
    defaultMessage: 'Switch to grid view',
    description: 'Accessible label for the library view toggle when table view is active',
  },
  searchPlaceholder: {
    id: 'library.header.searchPlaceholder',
    defaultMessage: 'Search Library',
    description: 'Placeholder text for the library search input',
  },
  filterButton: {
    id: 'library.header.filterButton',
    defaultMessage: 'Filter',
    description: 'Label for the library filter button',
  },
  previewLoading: {
    id: 'library.preview.loading',
    defaultMessage: 'Loading preview',
    description: 'Screen reader text shown while a file preview is loading',
  },
  previewNotAvailable: {
    id: 'library.preview.notAvailable',
    defaultMessage: 'Preview not available',
    description: 'Title shown when a file cannot be previewed in the browser',
  },
  previewPowerpointHint: {
    id: 'library.preview.powerpointHint',
    defaultMessage: "PowerPoint files can't be previewed in the browser. Please download to view.",
    description: 'Hint shown when a PowerPoint file cannot be previewed',
  },
  previewUnsupported: {
    id: 'library.preview.unsupported',
    defaultMessage: "This file type can't be previewed.",
    description: 'Fallback message shown when a file type cannot be previewed',
  },
  previewRenderError: {
    id: 'library.preview.renderError',
    defaultMessage: 'Unable to render preview',
    description: 'Error shown when a file preview fails to render',
  },
  previewDownload: {
    id: 'library.preview.download',
    defaultMessage: 'Download',
    description: 'Button label to download a file when preview is unavailable',
  },
  previewFallbackTitle: {
    id: 'library.preview.fallbackTitle',
    defaultMessage: 'Preview',
    description: 'Fallback title for the file preview modal when no file name is set',
  },
  previewPdfTitle: {
    id: 'library.preview.pdfTitle',
    defaultMessage: 'PDF preview',
    description: 'Title for the embedded PDF preview iframe when no file name is set',
  },
  previewImageAlt: {
    id: 'library.preview.imageAlt',
    defaultMessage: 'preview',
    description: 'Fallback alt text for an image preview when no file name is set',
  },
});

export default messages;
